import type { CSSProperties } from "react";
import {
  AlignLeft,
  AlertTriangle,
  ArrowLeft,
  ArrowUp,
  Banknote,
  Bell,
  Building2,
  Cable,
  Calendar,
  Check,
  CircleCheck as CircleCheckIcon,
  CheckCircle,
  ChevronLeft,
  CircleAlert,
  CircleX,
  Clock,
  CloudUpload,
  CreditCard,
  Download,
  Eye,
  FileText,
  Filter,
  Flame,
  Image,
  Info,
  KeyRound,
  List,
  LoaderCircle,
  Lock,
  LogIn,
  Mail,
  MapPin,
  MessageCircle,
  Send,
  MoreHorizontal,
  Percent,
  Pencil,
  Phone,
  PieChart,
  Plus,
  Printer,
  QrCode,
  ReceiptText,
  RefreshCw,
  RotateCw,
  Search,
  ShieldCheck,
  ShoppingBag,
  Smartphone,
  Store,
  Tags,
  Tablet,
  Tag,
  Trash2,
  TrendingUp,
  Truck,
  User,
  Users,
  Volume2,
  WalletCards,
  X,
  type LucideIcon,
} from "lucide-react";

type IconProps = {
  style?: CSSProperties;
  className?: string;
};

function lucideIcon(Component: LucideIcon) {
  return function Icon({ style, className }: IconProps) {
    return (
      <Component
        aria-hidden="true"
        className={className}
        size="1em"
        strokeWidth={2.35}
        style={{
          display: "inline-block",
          flexShrink: 0,
          verticalAlign: "-0.125em",
          ...style,
        }}
      />
    );
  };
}

export const AlignLeftOutlined = lucideIcon(AlignLeft);
export const ApiOutlined = lucideIcon(Cable);
export const ArrowLeftOutlined = lucideIcon(ArrowLeft);
export const ArrowUpOutlined = lucideIcon(ArrowUp);
export const BankOutlined = lucideIcon(Building2);
export const BellOutlined = lucideIcon(Bell);
export const CalendarOutlined = lucideIcon(Calendar);
export const CarOutlined = lucideIcon(Truck);
export const CircleCheck = lucideIcon(CircleCheckIcon);
export const CheckCircleFilled = lucideIcon(CheckCircle);
export const CheckCircleOutlined = lucideIcon(CheckCircle);
export const CheckOutlined = lucideIcon(Check);
export const ClockCircleFilled = lucideIcon(Clock);
export const ClockCircleOutlined = lucideIcon(Clock);
export const CloseCircleOutlined = lucideIcon(CircleX);
export const CloseOutlined = lucideIcon(X);
export const CloudUploadOutlined = lucideIcon(CloudUpload);
export const ContainerOutlined = lucideIcon(ReceiptText);
export const CreditCardOutlined = lucideIcon(CreditCard);
export const DeleteOutlined = lucideIcon(Trash2);
export const DollarOutlined = lucideIcon(Banknote);
export const DownloadOutlined = lucideIcon(Download);
export const EditOutlined = lucideIcon(Pencil);
export const EllipsisOutlined = lucideIcon(MoreHorizontal);
export const MoreOutlined = EllipsisOutlined;
export const MessageOutlined = lucideIcon(MessageCircle);
export const SendOutlined = lucideIcon(Send);
export const EnvironmentOutlined = lucideIcon(MapPin);
export const EyeOutlined = lucideIcon(Eye);
export const FileTextOutlined = lucideIcon(FileText);
export const FilterOutlined = lucideIcon(Filter);
export const FireOutlined = lucideIcon(Flame);
export const InfoCircleFilled = lucideIcon(Info);
export const InfoCircleOutlined = lucideIcon(Info);
export const KeyOutlined = lucideIcon(KeyRound);
export const LeftOutlined = lucideIcon(ChevronLeft);
export const LoadingOutlined = lucideIcon(LoaderCircle);
export const LockOutlined = lucideIcon(Lock);
export const LoginOutlined = lucideIcon(LogIn);
export const MailOutlined = lucideIcon(Mail);
export const MobileOutlined = lucideIcon(Smartphone);
export const PercentageOutlined = lucideIcon(Percent);
export const PhoneOutlined = lucideIcon(Phone);
export const PictureOutlined = lucideIcon(Image);
export const PieChartOutlined = lucideIcon(PieChart);
export const PlusOutlined = lucideIcon(Plus);
export const PrinterOutlined = lucideIcon(Printer);
export const QrcodeOutlined = lucideIcon(QrCode);
export const RedoOutlined = lucideIcon(RotateCw);
export const ReloadOutlined = lucideIcon(RefreshCw);
export const RiseOutlined = lucideIcon(TrendingUp);
export const SafetyCertificateOutlined = lucideIcon(ShieldCheck);
export const SearchOutlined = lucideIcon(Search);
export const ShopOutlined = lucideIcon(Store);
export const ShoppingOutlined = lucideIcon(ShoppingBag);
export const SoundOutlined = lucideIcon(Volume2);
export const TabletOutlined = lucideIcon(Tablet);
export const TagOutlined = lucideIcon(Tag);
export const TagsOutlined = lucideIcon(Tags);
export const TeamOutlined = lucideIcon(Users);
export const TransactionOutlined = lucideIcon(ReceiptText);
export const UnorderedListOutlined = lucideIcon(List);
export const UserOutlined = lucideIcon(User);
export const WalletOutlined = lucideIcon(WalletCards);
export const WarningFilled = lucideIcon(AlertTriangle);
export const WarningOutlined = lucideIcon(CircleAlert);
